import React from 'react'
import Button from '../Reusable/Button'

const Intouch = () => {
    return (
        <div className='flex bg-[#161616] flex-col lg:gap-10 gap-5 lg:px-[8%] px-[4%] lg:pt-[6%] py-[3%] z-[500]'>
            <div className='flex w-full items-center justify-center'>
                <div className='lg:w-[40%] gap-4 w-full flex flex-col items-center justify-center'>
                    <p className='text-[55px] text-white font-semibold '>Get in touch</p>
                    <p className='text-[14px] text-[#ffffff] text-center'>Each product is crafted to optimize efficiency, enhance sustainability, and support fair trade practices across the globe."</p>
                </div>
            </div>
            <form className='flex flex-col gap-7' action="">
                <div className='flex items-center lg:flex-row flex-col gap-4 w-full justify-between'>
                    <input className='border-[1px] w-full border-blue-400 p-4 rounded-lg bg-transparent outline-none' type="text" placeholder='Full name' />
                    <input className='border-[1px] w-full border-blue-400 p-4 rounded-lg bg-transparent outline-none' type="email" placeholder='Email address' />
                </div>
                <div className='flex items-center lg:flex-row flex-col gap-4 w-full justify-between'>
                    <input className='border-[1px] w-full border-blue-400 p-4 rounded-lg bg-transparent outline-none' type="text" placeholder='Phone no' />
                    <input className='border-[1px] w-full border-blue-400 p-4 rounded-lg bg-transparent outline-none' type="text" placeholder='Miner model' />
                </div>
                <div className='flex items-center lg:flex-row flex-col gap-4 w-full justify-between'>
                    <select className='border-[1px] text-white text-opacity-40 w-full border-blue-400 p-4 rounded-lg bg-transparent outline-none' name="" id="">
                        <option value="">Topic</option>
                        <option value=""></option>
                        <option value=""></option>
                    </select>
                    <select  className='border-[1px] text-white text-opacity-40 w-full border-blue-400 p-4 rounded-lg bg-transparent outline-none' name="" id="">
                        <option value="">Require hosting?</option>
                        <option value=""></option>
                        <option value=""></option>
                    </select>
                </div>
                <div className='border-[1px] p-3 border-blue-400 rounded-lg'>
                        <textarea className='flex w-full outline-none bg-transparent' placeholder='Leave a message as detail as possible' rows={"8"} name="" id=""></textarea>
                        <div className='flex w-full justify-end'>
                            <Button
                                title={"Submit Now"}
                                link={"/"}
                            />
                        </div>
                    </div>
            </form>
        </div>
    )
}

export default Intouch